import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';

import css from './Text.module.css';

export const Text = React.forwardRef((props, ref) => {
  const { className = null, rootClassName = null, as = 'span', ...otherProps } = props;
  const Tag = as;
  const classes = classNames(rootClassName || css.span, className);

  return <Tag className={classes} {...otherProps} ref={ref} />;
});

Text.displayName = 'Text';

Text.propTypes = {
  rootClassName: string,
  className: string,
  children: node,
  as: string,
};
